module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), (_vm.data.description !== '') ? _c('div', {
    staticClass: "rte"
  }, [_vm._v(_vm._s(_vm.data.description))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.data.products), function(item) {
    return _c('product-grid-tile', {
      key: item.id,
      attrs: {
        "item": item
      }
    })
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f393bda", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f393bda","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CollectionView.vue
// module id = 53
// module chunks = 0